module.exports = __webpack_public_path__ + "static/media/theprotinestudio.887572c0.png";